import { gql } from "__generated__/gql";

export const CONTRACT_MUTATION = gql(`#graphql
mutation saveContractForm($input: ContractInput, $charter: Long, $createMatchingContracts: Boolean! = false, $remark: String) {
	saveContract(input: $input, charter: $charter, createMatchingContracts: $createMatchingContracts, remark: $remark) {
		id
	}
}
`);

export const BACK_TO_BACK_CONTRACT_MUTATION = gql(`#graphql
mutation saveBackToBackContractForm($input: ContractInput, $charter: Long, $remark: String) {
	saveBackToBackContract(input: $input, charter: $charter, remark: $remark) {
		purchase {
			id
			contractNumber
		}
		sales {
			id
			contractNumber
		}
	}
}
`);

export const CONTRACT_DETAIL_QUERY = gql(`#graphql
query contractDetails($id: Long!) {
	contract(id: $id) {
		id
		charterType
		charterSubtype
		contractNumber
		status {
			name
			color
			languageKeyPrefix
		}
		statusUpdatedOn
		description
		isEditable
		memo
		includePricingInNomination
		labels {
			id
			text
			type
			color
		}
		currency {
			isoCode
			rate
			symbol
		}
		creditor {
			id
			name
			applicationRelation
			customer
			operator
			shipManger
			isShipManager
			skipper
			supplier
			contacts {
				id
				name
				insertion
				surName
				email
			}
		}
		creditorContact {
			id
			name
		}
		debtor {
			id
			name
			applicationRelation
			customer
			operator
			shipManger
			isShipManager
			supplier
			contacts {
				id
				name
				insertion
				surName
				email
			}
		}
		debtorContact {
			id
			name
		}
		broker {
			id
			name
		}
		validFrom
		validUntil
		noticePeriod
		versionNumber
		allIn
		sendHistoryItems {
			id
			timestamp
			status {
				name
				color
				languageKeyPrefix
			}
			versionNumber
			sendBy {
				id
				username
			}
			language {
				code
			}
			recipientUser {
				id
				username
				email
			}
			recipientRelation {
				id
				name
				email
			}
			recipientContact {
				id
				name
				email
			}
			recipientEmail
		}
		comments {
			...comment
		}
		isParentContract
		parentContract {
			id
			contractNumber
		}
		regions {
			id
			description
		}
		productCategory {
			id
			name
		}
		contractOptions {
			id
			validFrom
			validUntil
			description
			indexationType
			indexationDate
			indexationAmount
			useEndPriceOfTheContract
			pricePerUnit
			indexedPricePerUnit
			optionTaken
			noticePeriod
		}
		originalContractForOption {
			id
			contractNumber
		}
		takenOptionContract {
			id
			contractNumber
		}
		backToBackContract {
			id
			contractNumber
		}
		termsAndConditions {
			description
		}
	}
}
`);

export const CONTRACT_FORM_QUERY = gql(`#graphql
query contractForm($id: Long!) {
	contract(id: $id) {
		id
		charterType
		charterSubtype
		contractNumber
		status {
			name
			color
			languageKeyPrefix
		}
		description
		memo
		includePricingInNomination
		labels {
			id
			type
			text
			color
		}
		currency {
			rate
			symbol
			isoCode
		}
		creditor {
			id
			name
			contacts {
				id
				name
			}
		}
		debtor {
			id
			name
			contacts {
				id
				name
			}
		}
		creditorContact {
			id
			name
		}
		debtorContact {
			id
			name
		}
		broker {
			id
			name
		}
		validFrom
		validUntil
		noticePeriod
		versionNumber
		allIn
		regions {
			...CompactLocation
			type
			locationGroups {
				...CompactLocation
				type
			}
		}
		productCategory {
			id
			name
		}
		charters {
			id
			charterNumber
			type
			... on SalesCharter {
				voyages(from:null, to:null, excludeEmpty: false) {
					id
					voyageNumber
					ship {
						id
						name
					}
				}
			}
			... on PurchaseCharter {
				validFrom
				validUntil

				voyages(from:null, to:null, excludeEmpty: false) {
					id
					voyageNumber
					ship {
						id
						name
					}
					start
					end
				}
			}
		}
		isParentContract
		parentContract {
			id
			charterType
			charterSubtype
			contractNumber
		}
		contractChildren {
			id
			charterType
			charterSubtype
			contractNumber
		}
		contractOptions {
			id
			contract {
				id
			}
			description
			indexationDate
			indexationType
			indexationAmount
			noticePeriod
			validFrom
			validUntil
			optionTaken
			useEndPriceOfTheContract
			pricePerUnit
		}
		takenOptionContract {
			id
			contractNumber
		}
		backToBackContract {
			id
		}
		termsAndConditions {
			id
			description
		}
	}
}
`);

export const CHARTER_QUERY = gql(`#graphql
query contractPageGetCharter($id: Long!) {
	charter(id: $id) {
		id
		charterNumber
		creditor {
			id
			name
		}
		debtor {
			id
			name
		}
		type
		subtype
		... on SalesCharter {
			validFrom
			validUntil
		}
		... on PurchaseCharter {
			voyages(from: null, to: null, excludeEmpty: false) {
				ship {
					id
					name
				}
			}
			validFrom
			validUntil
		}
	}
}
`);

export const checkCopiedAgreementsChanged_query = gql(`#graphql
query checkCopiedAgreementsChanged($from: Long!, $to: Long!) {
	copiedAgreementsChanged(from: $from, to: $to)
}
`);

export const sendContractMail_mutation = gql(`#graphql
   mutation sendContractMail($input: SendContractInput!) {
	   sendContractMail(input: $input)
   }
`);

export const copyAgreements_mutation = gql(`#graphql
	mutation copyAgreements($from: Long!, $to: Long!) {
		copyAgreements(from: $from, to: $to)
	}
`);

export const updateAgreementsHaveChanged_mutation = gql(`#graphql
	mutation updateAgreementsHaveChanged($contractId: Long!, $agreementsHaveChanged: Boolean!) {
		updateAgreementsHaveChanged(contractId: $contractId, agreementsHaveChanged: $agreementsHaveChanged)
	}
`);
